// Bildmarke von LagerPro.
//
// Drei Kisten in aufsteigender Höhe mit einer Linie darüber: Lagerbestand und
// Wachstum in einer Form. Die Deckelkanten sind wichtig — ohne sie liest sich
// das Zeichen als Balkendiagramm und nicht als Ware.
//
// Gezeichnet in `currentColor`, damit es die Farbe seines Umfelds annimmt:
// weiß auf der Markenkachel, indigo freigestellt, hell auf dunklem Grund.

export function Logo({ klasse = '' }: { klasse?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={klasse} aria-hidden focusable="false"
         fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <rect x="5"  y="38" width="16" height="21" rx="2.5" opacity=".4" />
      <rect x="5"  y="38" width="16" height="6"  rx="2.5" opacity=".65" />
      <rect x="24" y="27" width="16" height="32" rx="2.5" opacity=".7" />
      <rect x="24" y="27" width="16" height="6"  rx="2.5" opacity=".9" />
      <rect x="43" y="14" width="16" height="45" rx="2.5" />
      <rect x="43" y="14" width="16" height="6"  rx="2.5" opacity=".75" />
      <path d="M13 30 L32 19 L51 6" fill="none" stroke="currentColor" strokeWidth="4.5"
            strokeLinecap="round" strokeLinejoin="round" opacity=".5" />
    </svg>
  );
}

/**
 * Die Marke als Kachel — so tritt sie überall auf, wo LagerPro sich vorstellt:
 * Startseite, Anmeldung, Seitenleiste.
 */
export function LogoKachel({ groesse = 'mittel', klasse = '' }: {
  groesse?: 'klein' | 'mittel' | 'gross';
  klasse?: string;
}) {
  const masse = {
    klein:  'h-8 w-8 rounded-lg',
    mittel: 'h-9 w-9 rounded-xl',
    gross:  'h-14 w-14 rounded-2xl',
  }[groesse];
  const innen = {
    klein: 'h-[18px] w-[18px]', mittel: 'h-5 w-5', gross: 'h-8 w-8',
  }[groesse];

  return (
    <span className={`grid shrink-0 place-items-center bg-marke-600 text-white ${masse} ${klasse}`}>
      <Logo klasse={innen} />
    </span>
  );
}
